export default __webpack_public_path__ + "static/media/empathy.ebc5d81e.webp";